export default function checkIfLoggedIn() {
  const selectors = {
    customerId: '[data-customer-id]',
  }

  const customerIdElement = document.querySelector(selectors.customerId);

  if (customerIdElement.innerText !== '') return true
  return false
}